import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../AuthProvider/AuthProvider'
import AdminWrapper from '../../Pages/Skeleton/WrapperAuth/AdminWrapper/AdminWrapper'
import { getUserRole } from 'Helpers/getUserRole'
import { ProfileProvider } from 'Context/ProfileContext'

const ProtectedAdmin = () => {
  // const {isAuthenticated} = useAuth0();
  const { isLocalAuth } = useAuth()
  const userRole = getUserRole()

  if (['employee'].includes(userRole)) {
    return <Navigate to='/' />
  }

  switch (isLocalAuth) {
    case false:
      return <Navigate to='/login' />
    case true:
      return (
        <ProfileProvider>
          <AdminWrapper>
            <Outlet />
          </AdminWrapper>
        </ProfileProvider>
      )
    default:
      return <Navigate to='/login' />
  }
}

export default ProtectedAdmin
